import React, {Component} from 'react'
import {
    Container,
    Row,
    Col,
    Input,
    Button,
    ListGroup,
    ListGroupItem, Label, FormGroup, CardHeader, CardBody, Card
} from 'reactstrap'


import classes from './PollDisplay.module.css'


import {faArrowLeft, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import firebase from "../../Config/firebase";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import NewPost from "../NewPost/NewPost";
import {MDBBtn, MDBContainer} from "mdbreact";

const db = firebase.firestore()

class RealtimePoll extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uid: this.props.auth.uid,
            isLoaded: true,
            isOldFile: '',
            newPoll: {
                pollTitle: '',
                pollOption: [],
            },
            keys: this.props.keys
        }
        /*  this.submitNewPoll.bind(this)
          this.getOptions()*/
    }

    componentDidMount() {
        this.setState({
            isLoaded: true
        })
    }

    componentWillReceiveProps(nextProps) {
        /*if (this.props.LearningElementDetail !== nextProps.LearningElementDetail) {
            this.setState({
                isLoaded: true
            }, () => {
                this.getOptions()
            })
        }*/
    }

    componentWillUnmount() {

    }

    /*getOptions = async () => {
        const keys = this.props.keys.split('/')
        let getState;

        if (getState.data !== null) {
            this.setState({
                newPoll: {
                    ...this.state.newPoll,
                    pollOption: getState
                }
            }, () => {
                this.setState({
                    isLoaded: true
                })
            })
        }
    }*/


    onChangePollTitle = (val) => {
        this.props.onChangePollTitle(val)
        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollTitle: val
            }
        })
    }

    addOption = async () => {
        const newOption = {
            optionName: '',
            count: 0,
            createUserID: this.state.uid,
            votedMember: []
        }
        this.props.addOption(newOption)
        const newArr = this.state.newPoll.pollOption.concat(newOption)
        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: newArr
            }
        })
    }

    returnPoll = () => {
        console.log(this.state.newPoll)
        return this.state.newPoll

    }


    changeOptionName = (optName, index, optionUID) => {
        let options = this.state.newPoll.pollOption
        let editOption = this.state.newPoll.pollOption[index]
        editOption = {
            optionName: optName,
            count: editOption.count,
            createUserID: this.state.uid,
            votedMember: []
        }
        this.props.changeOptionName(editOption, index, options)
        options[index] = editOption

        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: options
            }
        })
    }

    deleteOption = async (index, optionUID) => {
        this.props.deleteOption(index)
        this.state.newPoll.pollOption.splice(index, 1)
        const options = this.state.newPoll.pollOption
        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: options
            }
        })
    }


    render() {
        return (

            <Card>
                <CardHeader>
                    新增投票
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Label className={classes.Label}>
                            標題
                        </Label>
                        <Input type="text" name="pollTitle" id="pollTitle"
                               placeholder="pollTitle"
                               onChange={(e) => this.onChangePollTitle(e.target.value)}
                               value={this.state.newPoll.pollTitle}

                        />
                    </FormGroup>
                    <div>
                        <FormGroup>
                            <Label className={classes.Label}>選擇 ({this.state.newPoll.pollOption.length})</Label>

                            <ListGroup className={classes.AddOptionList}>
                                {
                                    this.state.newPoll.pollOption.map((opt, index) => {
                                        return (
                                            <ListGroupItem key={index} className={classes.PollOptionItem}>
                                                <Input key={index + 'pollInput'}
                                                       type='text'
                                                       placeholder={"option " + (index + 1)}
                                                       className={classes.PollOptionInput}
                                                       value={opt.optionName}
                                                       onChange={(e) => {
                                                           this.changeOptionName(e.target.value, index)
                                                       }}
                                                />
                                                <MDBBtn color='link' key={index + 'delPollOpt'}
                                                        className={classes.DeleteBtn}
                                                        onClick={(e) => {
                                                            this.deleteOption(index, opt.hasOwnProperty('UID') ? opt.UID : opt.key)
                                                        }}
                                                >
                                                    <FontAwesomeIcon icon={faTrashAlt}/>
                                                </MDBBtn>
                                            </ListGroupItem>
                                        )
                                    })
                                }
                                <ListGroupItem>
                                    <MDBBtn onClick={(e) => {
                                        this.addOption()
                                    }}>
                                        新增選擇
                                    </MDBBtn>
                                </ListGroupItem>
                            </ListGroup>
                        </FormGroup>
                    </div>

                </CardBody>
            </Card>
        )
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(RealtimePoll))